import { Geolocation } from '@app-types/dealer.types'

export interface Marker {
    objectID: string
    lat: number
    lng: number
    name: string
    website: string
    street: string
    postalCode: string
    city: string
    icon: 'dealer' | 'dealer-shop' | 'webshop'
    brands: string[]
    country: string
    country_code: string | undefined
}

export interface LocationMarker {
    position: Geolocation
}

export enum Brands {
    woood = 'woood',
    bepurehome = 'bepurehome',
    vtwonen = 'vtwonen',
}
